var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.displayedUsers),function(avatar,i){return _c('UserAvatar',{key:i,staticClass:"-ml-2 border rounded-full",attrs:{"item":avatar}})}),_vm._v(" "+_vm._s(_vm.avatarsNotMe.length > _vm.getCurrentVersionUsersLimit() ? (_vm.avatarsNotMe.length) : "")+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }